import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { STUDIO_ACCESS_TIER } from 'Pods/ThreeDStudio/Store/constants'

const EXPORT_TIERS = new Set([
  STUDIO_ACCESS_TIER.SUBSCRIBED,
  STUDIO_ACCESS_TIER.HAS_CREDITS,
])

function useExportAccess() {
  const studioAccessTier = useThreeDStudioStore((state) => state.subscription.studioAccessTier)
  return EXPORT_TIERS.has(studioAccessTier)
}

export default useExportAccess
